(function($, undefined) {
	"use strict";
	let form;

	function disableAvailability({value}) {		
		const input = $(`[name=fullAccess][value=${value}]`);
		const inputContext = input.closest('.add-location-settings__block');
		const inputTitle = inputContext.prev();
		// Check the same value for full Access
		// In order to give "more" chance that the emergency will have the full access to a building
		input.prop("checked", true);
		if(JSON.parse(value)) {
			// Show the fullAccss section
			inputContext.slideDown();
			inputTitle.slideDown();
		} else {
			// Hide the fullAccess section
			// because we've already checked the
			// Do you want to allow Emergency services to get to your location info ?
			// to NO
			inputContext.slideUp();
			inputTitle.slideUp();
		}
	}

	function init() {
		// Set form context
		form = $('.wizard_step1 .wizard__questions');
		// Trigger on change
		$('[name=permission]', form).change(({currentTarget}) => disableAvailability(currentTarget));
	}
	
	$(init);
	
})(jQuery);